import { type Common } from '../common.js';
import { type FlowRunBlockWithData } from '../models/flow/flowRun.js';
import {
  type FlowRunExploreDownloadResponse,
  type FlowRunExploreExportOptions,
  type FlowRunExploreExportResponse,
  type FlowRunExploreFindAllOptions,
  type FlowRunExploreFindAllResponse,
  type FlowRunExploreGetColumnsOptions,
  type FlowRunExploreGetColumnsResponse,
  type FlowRunExploreRunShell,
} from '../models/flow/flowRunExplore.js';
export class API {
  common: Common;
  baseEndpoint = '/flow/flow-runs/explore';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    queryParams?: FlowRunExploreFindAllOptions
  ): Promise<FlowRunExploreFindAllResponse> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async getColumns(
    queryParams?: FlowRunExploreGetColumnsOptions
  ): Promise<FlowRunExploreGetColumnsResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/columns`, queryParams);
    return await this.common.getJSON(url);
  }

  async export(body?: FlowRunExploreExportOptions): Promise<FlowRunExploreExportResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/export`);
    return await this.common.postJSON(url, body);
  }

  async download(body?: FlowRunExploreExportOptions): Promise<FlowRunExploreDownloadResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/download`);
    return await this.common.postJSON(url, body);
  }

  async findOneRunById(flowRunId: string): Promise<{ flowRun: FlowRunExploreRunShell }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/runs/${flowRunId}`);
    return await this.common.getJSON(url);
  }

  async findOneBlockById(flowRunId: string, blockId: string): Promise<FlowRunBlockWithData> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/runs/${flowRunId}/blocks/${blockId}`
    );
    const response: { flowRunBlock: FlowRunBlockWithData } = await this.common.getJSON(url);
    return response.flowRunBlock;
  }
}
